import { IconButton, IconName, useFavoriteSecurities } from '@talos/kyoko';
import type { ICellRendererParams } from 'ag-grid-community';
import { useCallback } from 'react';
import type { PriceGridEntity } from '../PriceGridEntity';

export function PriceGridFavoriteCellRenderer({ data, value }: ICellRendererParams<PriceGridEntity, boolean>) {
  const { favoriteSecurities, setFavoriteSecurities } = useFavoriteSecurities();
  const symbol = data?.security.Symbol;
  const isFavorite = value === true;

  const handleFavoriteToggled = useCallback(() => {
    if (!symbol) {
      return;
    }
    setFavoriteSecurities(
      isFavorite
        ? favoriteSecurities.filter(favoriteSymbol => favoriteSymbol !== symbol)
        : [...favoriteSecurities, symbol]
    );
  }, [favoriteSecurities, isFavorite, setFavoriteSecurities, symbol]);

  if (!symbol || !data?.isParentRow) {
    return null;
  }

  return (
    <IconButton
      ghost
      icon={isFavorite ? IconName.StarSolid : IconName.Star}
      color={isFavorite ? 'yellow.lighten' : 'gray.080'}
      data-testid={`price-grid-favorite-${symbol}`}
      data-checked={isFavorite}
      onClick={event => {
        event.stopPropagation();
        event.preventDefault();
        handleFavoriteToggled();
      }}
    />
  );
}
